/**
 * The text to show when a keyon medication call is refused.
 *
 * Medication Administration and Current Medications alerted "Code:340 - System issue" for every refusal, so keyon's own reason (a 403 for
 * an account that cannot release a hold, a 404 for a medication that is not
 * found) never reached the user; pre-pour already showed it (api/prepourApi.js).
 * Takes an axios error or a reply body; keyon's message, then its error text,
 * then the old system-issue text.
 */

export const SYSTEM_ISSUE = "Code:340 - System issue. Please contact system support";

function bodyOf(errorOrData) {
  if (!errorOrData) return null;
  if (errorOrData instanceof Error && !errorOrData.isAxiosError) return null; // a page error, not keyon's answer
  const body = errorOrData.isAxiosError ? errorOrData.response?.data : errorOrData;
  if (typeof body === "string") {
    try {
      return JSON.parse(body);
    } catch (e) {
      return null;
    }
  }
  return body && typeof body === "object" ? body : null;
}

export function keyonRefusalMessage(errorOrData) {
  const body = bodyOf(errorOrData);
  if (!body) return SYSTEM_ISSUE;
  for (const text of [body.message, body.error]) {
    if (typeof text === "string" && text.trim()) return text.trim();
  }
  return SYSTEM_ISSUE;
}
